var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMail = function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#iconMail_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fillOpacity: 0.12,
    rx: 3.333
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.36,
    d: "M14.166 13.648H5.833a.52.52 0 0 1-.521-.521V8.688l4.687 1.875 4.688-1.875v4.439c0 .287-.234.52-.52.52m.52-7.292v1.21L10 9.44 5.312 7.565V6.356zM4.27 5.314v7.813c0 .861.701 1.563 1.563 1.563h8.333c.862 0 1.563-.702 1.563-1.563V5.314z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconMail_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconMail;